import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import { useVerifyBookingByQrMutation } from "../../Redux/apis/ApiSlice";
import { notification } from "antd";
import dayjs from "dayjs";

const YOUR_SECRET_KEY = "Zeee@37104";
const TicketInfo = () => {
  const location = useLocation(); // Access state from navigation
  const fullLink = window.location.search; // Full query string starting with '?'
  const [verifyBookingByQr] = useVerifyBookingByQrMutation();
  // Check if we are coming from the "Verify Code" screen or QR scanning
  const isFromVerifyCode = location.state && location.state.booking;

  // Handle data depending on source (Verify Code or QR scannings)
  let bookingData;
  const linkWithoutBaseURL = fullLink.substring(1); // Removes the leading '?'

  // Decrypt the link
  const decryptData = (encryptedText) => {
    const bytes = CryptoJS.AES.decrypt(encryptedText, YOUR_SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  };

  let decryptedData;
  try {
    decryptedData = decryptData(linkWithoutBaseURL); // Decrypt the link
  } catch (error) {
    console.error("Failed to decrypt data:", error);
    decryptedData = ""; // Set to empty if decryption fails
  }

  // Parse the decrypted data as query parameters
  const params = new URLSearchParams(decryptedData);

  // Extract query parameters
  var ticketCode = params.get("ticketCode");
  var eventId = params.get("eventId");
  var eventName = decodeURIComponent(params.get("eventName"));
  var eventLocation = decodeURIComponent(params.get("location"));
  var buyerName = decodeURIComponent(params.get("buyerName"));
  var date = params.get("date");
  var time = decodeURIComponent(params.get("time"));
  var status = params.get("status");
  var totalPrice = params.get("totalPrice");
  var bookingId = params.get("bookingId");
  const ticketTypesStr = decodeURIComponent(params.get("ticketTypes") || "[]");

  // Parse ticketTypes JSON string
  let ticketTypes = [];
  try {
    ticketTypes = JSON.parse(ticketTypesStr);
  } catch (error) {
    console.error("Failed to parse ticketTypes:", error);
  }
  // }
  const userData = localStorage.getItem("userData");
  const parsedData = JSON.parse(userData);
  // Extract the id
  const userId = parsedData?.id;
  const handleScanComplete = async () => {
    try {
      const response = await verifyBookingByQr({
        eventId: Number(eventId),
        userId: Number(userId),
        bookingId: Number(bookingId),
        ticketCode: Number(ticketCode),
      }).unwrap();
      notification.success({ message: "Verification successful!" });
      // Show the result modal or popup only on success
    } catch (err) {
      console.error("Verification failed:", err);
      notification.error({
        message: err?.data?.error || "You can't scan this QR!",
      });
    }
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensures 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="92.5vh"
      bgcolor="#f5f5f5"
    >
      <Box
        sx={{
          padding: "20px",
          borderRadius: "10px",
          boxShadow: 3,
          bgcolor: "white",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h6"
          align="left"
          sx={{ mb: 2 }}
          fontWeight={"bold"}
        >
          Ticket Info
        </Typography>
        <Grid item xs={12} mb={2} align="left">
          <Typography variant="body1">
            Event Date: {dayjs(time).format("MM/DD/YYYY")}
          </Typography>
          <Typography variant="h5">{eventName}</Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6} align="left">
            <Typography variant="body2" fontWeight={"bold"}>
              Buyer
            </Typography>
            <Typography variant="body1">{buyerName}</Typography>
          </Grid>
          <Grid item xs={6} align="right" mb={1}>
            <Typography variant="body2" fontWeight={"bold"}>
              Event Name
            </Typography>
            <Typography variant="body1">{eventName}</Typography>
          </Grid>

          {/* Ticket Details with Booked Quantities */}

          <Grid item xs={6} align="left">
            <Typography variant="body2" fontWeight={"bold"}>
              Location
            </Typography>
            <Typography variant="body1">{eventLocation}</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            align="left"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
            }}
          >
            <Typography variant="body2" fontWeight={"bold"}>
              Event Time
            </Typography>
            <Typography variant="body1">
              {dayjs(time).format("hh:mm A")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            align="right"
            sx={{
              textAlign: "start",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="body2" fontWeight={"bold"}>
              Total Price
            </Typography>
            <Typography variant="body1">${totalPrice}</Typography>
          </Grid>

          <Grid
            item
            xs={6}
            align="left"
            sx={{ display: "flex", flexDirection: "column", alignItems: "end" }}
          >
            {ticketTypes ? (
              <>
                <Typography variant="body2" fontWeight={"bold"} pl={"1rem"}>
                  Ticket Types
                </Typography>
                <Typography variant="body1" pl={"1rem"}>
                  {ticketTypes?.type}
                </Typography>
              </>
            ) : (
              <Typography variant="body1">.</Typography>
            )}
          </Grid>
        </Grid>
        <Box
          sx={{
            marginTop: "20px",
            marginBottom: "20px",
            width: "100%",
            height: "200px",
            backgroundImage:
              "url(https://t4.ftcdn.net/jpg/02/16/94/65/360_F_216946587_rmug8FCNgpDCPQlstiCJ0CAXJ2sqPRU7.jpg)",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: "10px",
          }}
        />
        <Box sx={{ marginTop: "10px" }}>
          <Button onClick={handleScanComplete} sx={{ border: "1px solid" }}>
            Authenticate
          </Button>
          <Typography
            variant="caption"
            display="block"
            style={{ marginTop: "5px" }}
          >
            Once authenticated, this ticket cannot be scanned again.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TicketInfo;
